// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '21px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  indicator: {
    backgroundColor: theme.black,
    height: '5px',
    width: '134px',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '100px',
    marginBottom: theme.other.spacing._8,
  },
}));

export default useStyles;
